// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"C6-z"};